module.exports = __webpack_public_path__ + "img/12.a53d7b80.png";